import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FAFAFA",
    color: "#666",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#171717",
  },
}));

export default StyledTableCell;
